import { CheckOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface SelectAllBarProps {
  allSelected: boolean;
  /** Няма редове за избор (празна сметка или само заключени). */
  disabled: boolean;
  discountedCount: number;
  selectableCount: number;
  /** „Премахни всички" се вижда само при поне един избран ред. */
  canRemoveAll: boolean;
  onToggleSelectAll: () => void;
  onRemoveAll: () => void;
  isNarrow: boolean;
}

/** Лентата над списъка: „Избери всички" + „N от M с отстъпка" вляво,
 *  „Премахни всички" вдясно. И двете само менят избора — записът е „Запази". */
export const SelectAllBar = ({
  allSelected,
  disabled,
  discountedCount,
  selectableCount,
  canRemoveAll,
  onToggleSelectAll,
  onRemoveAll,
  isNarrow,
}: SelectAllBarProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex items-center justify-between gap-3 border-b border-pos-line2 py-2.5 ${
        isNarrow ? "px-4" : "px-6"
      }`}
    >
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={onToggleSelectAll}
          disabled={disabled}
          className="inline-flex shrink-0 cursor-pointer items-center gap-2 border-0 bg-transparent p-0 text-[13.5px] font-semibold text-pos-ink2 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <span
            className={`inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[5px] border text-white transition-colors ${
              allSelected
                ? "border-pos-accent bg-pos-accent"
                : "border-pos-check bg-pos-card"
            }`}
          >
            {allSelected && <CheckOutlined className="text-[10px]" />}
          </span>
          <span>{t("itemDiscounts.selectAll")}</span>
        </button>
        <span className="truncate text-[12.5px] font-medium text-pos-muted">
          {t("itemDiscounts.discountedOfTotal", {
            discounted: discountedCount,
            total: selectableCount,
          })}
        </span>
      </div>
      {canRemoveAll && (
        <button
          type="button"
          onClick={onRemoveAll}
          className="shrink-0 cursor-pointer border-0 bg-transparent p-0 text-[13px] font-semibold text-pos-danger-ink underline-offset-2 hover:underline"
        >
          {t("itemDiscounts.removeAll")}
        </button>
      )}
    </div>
  );
};
